<template>
<div>
  <div class="detail" v-if="!show_1 && !show_2">
    <div class="header">
      <div class="left" @click="toIndex()">< 返回</div>
      <div class="span1">
        <span>课程详情</span>
      </div>
      <div class="right"></div>
    </div>
    <div>
      <el-form ref="form" :inline="true" :model="form" label-width="90px">
        <el-form-item label="">
          <el-select
            v-model="form.q"
            clearable
            placeholder="请选择区域"
          >
            <el-option
              v-for="item in qList"
              :key="item.id"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="">
          <el-input
            v-model="form.courseName"
            clearable
            placeholder="请输入课程名称"
          />
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" size="small" @click="getDataList"
            >搜索</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 校内教师 -->
      <div class="table">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="courseName" label="课程名称" align="center">
          </el-table-column>
          <el-table-column prop="teacherName" label="授课教师" align="center">
          </el-table-column>
          <el-table-column prop="a" label="覆盖区域" align="center">
          </el-table-column>
          <el-table-column prop="gradeName" label="覆盖年级" align="center">
          </el-table-column>
          <el-table-column prop="classNum" label="课时总数" align="center">
          </el-table-column>
          <el-table-column prop="selectedCount" label="学校开课次数" align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" width="200">
            <template slot-scope="scope">
              <!-- <el-button type="text" @click="toDetail(scope.row)">课程详情</el-button> -->
              <el-button type="text" @click="toList(scope.row)">学校开课详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <!--分页组件-->
          <el-pagination
            background
            :current-page="page.pageNum"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="page.pageSize"
            :total="page.totalPage"
            layout="total,prev, pager, next,jumper,sizes"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
          ></el-pagination>
        </div>
      </div>
    </div>
  </div>
  <DetailList v-if="show_1" @go-home="goHome" :info="info_1"></DetailList>
  <DetailText v-if="show_2" @go-home="goHome" :info="info_2"></DetailText>
</div>
</template>
<script>
import api from "@/api/wisdomSchool/index";
export default {
  props: {
    info: {
      type: Object,
      default: {},
    },
  },
  components:{
    DetailList: ()=>import('./detail_list.vue'),
    DetailText: ()=>import('./detail_text.vue'),
  },
  data() {
    return {
      form: {
        campus: "",
        schoolYearSemester: "",
        gradeId: "",
        courseName: "",
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 0,
      },
      semesterArr: JSON.parse(sessionStorage.getItem("semesterList"))||[],
      qList: [
        
      ],
      tableData: [
        {courseName:'世界百科',teacherName:'王恩龙',a:"汉阳区",gradeName:'一年级二年级',classNum:'72',selectedCount:'43'},
        {courseName:'幸福劳动课',teacherName:'吴博俊',a:"东西湖区",gradeName:'二年级三年级',classNum:'26',selectedCount:'43'},
        {courseName:'世界百科课',teacherName:'喻环韵',a:"汉阳区",gradeName:'三年级四年级',classNum:'56',selectedCount:'43'},
        {courseName:'美学鉴赏课',teacherName:'曾歌菁',a:"江岸区",gradeName:'一年级二年级',classNum:'36',selectedCount:'43'},
        {courseName:'体适能课',teacherName:'喻环韵',a:"青山区",gradeName:'四年级五年级',classNum:'36',selectedCount:'43'},
        {courseName:'中文阅读',teacherName:'伍萍桂',a:"洪山区",gradeName:'五年级六年级',classNum:'26',selectedCount:'43'},
      ],
      school_info: JSON.parse(sessionStorage.getItem("classList"))||[],
      show_1:false,
      show_2:false,
      info_1:{},
      info_2:{},
    };
  },
  watch: {
  
  },
  mounted() {},
  created() {
    this.getDataList();
    this.campusList = this.school_info.slice();
  },
  methods: {
    async getDataList() {
      let params = {
        schoolYearSemester: this.form.schoolYearSemester,
        gradeId: this.form.gradeId,
        courseName: this.form.courseName,
        extOrgName: this.info.extOrgName,
        typeId: "",
        teacherId: "",
        orgId:sessionStorage.getItem('orgId'),
        platformCode:sessionStorage.getItem('platformCode'),
        page: this.page.pageNum,
        limit: this.page.pageSize,
      };
      // var { data, code } = await api.handleCourseList(params);
      // console.log("获取列表数据---", data, code);
      // if (code == "0") {
      //   this.tableData = data.list;
      //   this.page.totalPage = data.total;
      // }
    },
    searchFun() {
      this.page.pageNum = 1;
      this.getDataList();
    },
    sizeChangeHandle(val) {
      this.tableData = [];
      this.page.pageSize = val;
      this.getDataList();
    },

    currentChangeHandle(val) {
      this.tableData = [];
      this.page.pageNum = val;
      this.getDataList();
    },

    toIndex() {
      this.$emit("to-index");
    },

    toDetail(item){

    },
    toList(item){
      this.info_1 = item,
      this.show_1 = true;
    },
    goHome() {
      this.show_1 = false;
      this.show_2 = false;
    },
  },
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }

  ::v-deep .el-form .el-input__inner {
    width: 189px;
    height: 32px;
    border-radius: 3px;
    background: #fff;
    border: 1px solid #ddd;
  }

  ::v-deep .el-table__header tr th {
    background: #f7f7f7;
    box-shadow: 0px 1px 0px #eaeaea;
  }

  ::v-deep .el-date-editor .el-range-separator {
    line-height: 22px;
  }

  .pagination {
    text-align: center;
    margin-top: 30px;
  }
}
</style>
